export default "__VITE_ASSET__EFpfd8wz__"